import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';

export class GetVehicleModelsResponseExtensionClass implements IGetVehicleModelsResponse {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Models: IVehicleModel[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Models = undefined;
        if (odataObject.Models) {
            this.Models = [];
            for (var i = 0; i < odataObject.Models.length; i++) {
                if (odataObject.Models[i]) {
                    if (odataObject.Models[i]['@odata.type']) {
                        var className: string = odataObject.Models[i]['@odata.type'];
                        className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
                        if ((EntityClasses as any)[className]) {
                            this.Models[i] = new (EntityClasses as any)[className](odataObject.Models[i]);
                        }
                    } else {
                        this.Models[i] = new VehicleModelExtensionClass(odataObject.Models[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.Models[i] = undefined;
                }
            }
        }
    }
}

export class VehicleModelExtensionClass implements IVehicleModel {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Id: number;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Name: string;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Id = odataObject.Id;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Name = odataObject.Name;
    }
}

export interface IGetVehicleModelsResponse {
    Models?: IVehicleModel[];
}

export type IVehicleModel = {
    Id: number | 'all';
    Name?: string;
};

function vehicleModelsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function vehicleModelsInput(typeId: number, makeId: number): IDataServiceRequest {
    const query = vehicleModelsQuery();
    return query.createDataServiceRequestForOperation(
        'VehicleModels',
        false,
        GetVehicleModelsResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'IGetVehicleModelsResponse' },
        {
            typeId: typeId,
            makeId: makeId
        }
    );
}

export function getVehicleModelsAsync(
    context: IContext,
    typeId: number,
    makeId: number
): AsyncResult<IGetVehicleModelsResponse> {
    const request = vehicleModelsInput(typeId, makeId);
    return callActionOrExecute<IGetVehicleModelsResponse>(request, context.callerContext);
}
